export function isManual(testingString: string | undefined) {
  return testingString === 'Manual';
}
